var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icons && _vm.icons.length > 0)?_c('section',{staticClass:"g-df-vc shop-icons"},_vm._l((_vm.icons),function(num){return _c('img',{key:num,attrs:{"src":_vm.shopIcons[num],"alt":""}})}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }